import { Building2, LayoutDashboard, Shield, ShieldCheck, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

import { BrandMark } from '@/components/BrandMark';
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';

import { PortalLayout, type NavSection, type PortalMenuItem } from './PortalLayout';

const NAV_SECTIONS: NavSection[] = [
  {
    label: 'Navigation',
    items: [
      { to: '/org', label: 'Dashboard', icon: LayoutDashboard, end: true },
      { to: '/org/properties', label: 'Properties', icon: Building2 },
      { to: '/org/admins', label: 'Users', icon: Users },
      { to: '/org/compliance', label: 'Compliance', icon: ShieldCheck },
    ],
  },
];

const MENU_ITEMS: PortalMenuItem[] = [
  { to: '/org/account/privacy', label: 'Privacy & Data', icon: Shield },
];

const BRAND = (
  <SidebarMenu>
    <SidebarMenuItem>
      <SidebarMenuButton size="lg" asChild>
        <Link to="/org">
          <BrandMark className="size-8 shrink-0" aria-hidden />
          <div className="flex flex-col items-start min-w-0">
            <span className="font-semibold tracking-tight">Secure Labs</span>
            <span className="text-xs text-muted-foreground">Org Admin</span>
          </div>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  </SidebarMenu>
);

export function OrgAdminLayout() {
  return (
    <PortalLayout
      brand={BRAND}
      navSections={NAV_SECTIONS}
      notificationsTo="/org/notifications"
      menuItems={MENU_ITEMS}
    />
  );
}
